<template>
  <section class="ecom body">
    <router-view />
  </section>
</template>

<script>
export default {
  mounted () {
    if (process.env.VUE_APP_RECAPTCHA_KEY != null && process.env.VUE_APP_RECAPTCHA_KEY !== '') {
      const recpatchaScriptEl = document.createElement('script')
      const recpatchaScript = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.VUE_APP_RECAPTCHA_KEY}`
      recpatchaScriptEl.setAttribute('src', recpatchaScript)
      document.head.appendChild(recpatchaScriptEl)
    }
  }
}
</script>

// Do not remove - this has to be here so webpack will hot reload CSS
<style lang="scss">
// body {
//   color: red;
// }
</style>
